import moment from "moment";

export default function TimeAndAnswers(props) {
  const formattedData = moment(props.time).fromNow();

  if (props.box === "question") {
    return (
      <div className={`d-flex justify-content-between pt-15 pb-15 text-size-80 align-items-center sec-c `}>
        <div style={{ flexBasis: "25%" }} className="txt-center">
          <span>answers</span> <span>{props.length}</span>
        </div>
        <button
          className="view-post relative"
          style={{ backgroundColor: "transparent", flexBasis: "40%" }}
          onClick={props.onClick}>
          {props.view}
        </button>
        <span className="txt-center" style={{ flexBasis: "25%" }}>
          {formattedData}
        </span>
      </div>
    );
  } else if (props.box === "answer") {
    return <span className="block txt-center text-size-80">{formattedData}</span>;
  }
}
